/* import __COLOCATED_TEMPLATE__ from './subcategories-with-featured-topics.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
